export type CasinoOpenGamePayload = {
  _id: string | number
  identifier: string | number
  game_name: string
  game_images?: unknown
  game_provider?: unknown
  provider?: unknown
}

export function resolveCasinoCategoryFromGame(
  game: Record<string, unknown>,
  fallback = '100hp',
): string {
  const raw =
    game._providerCategory ??
    game.provider_id ??
    game.game_provider ??
    game.provider ??
    fallback
  const category = String(raw).trim()
  return category || fallback
}

export function normalizeCasinoOpenGame(game: Record<string, unknown>): CasinoOpenGamePayload {
  const id = String(game.identifier ?? game.game_id ?? game._id ?? '')
  return {
    _id: (game._id as string | number | undefined) ?? id,
    identifier: (game.identifier as string | number | undefined) ?? id,
    game_name: String(game.game_name ?? game.name ?? id),
    game_images: game.game_images ?? game.image_url ?? game.game_image,
    game_provider: game.game_provider ?? game.provider,
    provider: game.provider,
  }
}

/** Navigate target for launching a game on the canonical slots route. */
export function buildCasinoSlotsPlayTarget(
  game: Record<string, unknown>,
  options: { category?: string | null } = {},
) {
  const category = options.category?.trim() || resolveCasinoCategoryFromGame(game)
  return {
    pathname: '/casino-int/slots',
    search: `?category=${encodeURIComponent(category)}`,
    state: { openGame: normalizeCasinoOpenGame(game) },
  }
}
